import { ITemplate } from '@dataTypes/appointment.type'
import { default as axios } from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

// Define the types for the response structure
export type AuthResponse = {
  statusCode: number
  message: string
  data: {
    templates: ITemplate[]
  }
}

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_TEMPLATE')
const headers = {
  'Content-Type': 'application/json',
}

// Function to get access token
export const getAllTemplates = async (): Promise<AuthResponse> => {
  try {
    const { data, status } = await axios.get<AuthResponse>(
      `${BUSINESS_LAYER_API}/api/v1/templates`,
      {
        headers,
      },
    )

    // Check if the response status is 200, throw an error otherwise
    if (status !== 200) {
      throw new Error('Authentication failed')
    }
    return data
  } catch (e: any) {
    logger.error('error', e)
    throw toApiError(e, 'Error during authentication')
  }
}
